import { InfoElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class Info extends InfoElement {}
export default Info;